module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/jcb.120ed9c6.png";